import { ICardCommercialOffers } from './types'

import { Button, Divider, Drawer, Flex, Loader, Tab } from '@ui/index'
import { IconClearClose, IconMainGrid } from '@img/icons'
import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'

import css from './ui.module.scss'


/** Анкета комерческого предложения */
export const CardCommercialOffers = ({
    isOpen, cardMode, isLoadingCard, isDisableBtnSave, tabActive, siteDbName, cardID, txtDateCreate,
    getCardPage, handleBtnSave, handleBtnClose, handleOpenModalCommercialOffersGenerateDoc, handlerOpenModalConfirm
}: ICardCommercialOffers) => {
    const siteLogo = siteDbName === 'yaskill'
        ? {src: logoYaSkill, name: 'YaSkill'}
        : siteDbName === 'modern_academy'
            ? {src: logoModSkill, name: 'ModSkill'}
            : null

    const getCardPageBtnPanel = (tabActive: string) => {
        switch (tabActive) {
            case 'primary': {
                return <Flex gap='4px'>
                    <Divider />
                    <Flex flexWrap='wrap' flexDirection='row' gap='4px'>
                        <Flex flexDirection='row' gap='4px' isRendered={cardMode === 'edit'} className='mobile550'>
                        <Button variant='primaryDark' padding='0 10px' onClick={() => handleOpenModalCommercialOffersGenerateDoc(true)}>Сформировать</Button>
                        
                        <Button flexGrow={1} variant='primaryDark' padding='0 10px' onClick={() => 
                            handlerOpenModalConfirm(true, 'Отправка информации', 'Вы действительно хотите отправить информацию в telegram канал?', 'sendedTelegram')
                            }>Отправить</Button>
                            <Divider id='hiddenFor550' type='vertical' margin='8px' />
                        </Flex>

                        <Flex flexDirection='row' gap='4px' className='mobile550'>
                            <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoadingCard} onClick={() => handleBtnSave(true)}>Сохранить и закрыть</Button>
                            <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoadingCard} onClick={() => handleBtnSave(false)}>Сохранить</Button>
                        </Flex>
                    </Flex>
                </Flex>
            }
        }
    }

    return <>
        <Drawer isOpen={isOpen} placement='bottom' size='99.4%'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <header>
                        <Flex gap='6px' flexDirection='row' alignItems='center'>
                            {siteLogo && <img className={css['header_logo']} src={siteLogo.src} alt={`Логотип ${siteLogo.name}`} />}
                            <h4>{cardMode === 'edit' ? 'Анкета КП' : 'Создание КП'}</h4>
                        </Flex>

                        {cardMode === 'edit' && <h5>№ {cardID} от {txtDateCreate.value}</h5>}
                    </header>

                    <Button variant='icon' size='md' isDisabled={isLoadingCard} onClick={handleBtnClose}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body_bottom_panel'>
                    <Flex gap='6px' className='drawer_container-content'>
                        {getCardPage(tabActive.value)}
                    </Flex>

                    {getCardPageBtnPanel(tabActive.value)}
                </Flex>

                <Tab.Container isVisible={cardMode === 'edit'}>
                    <Tab.Item tabName='primary' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Основные данные' onClick={tabActive.setValue}><IconMainGrid /></Tab.Item>
                    {/* <Tab.Item tabName='help' tabNameActive={tabActive.value} tabToolTipPlace='top-start' tabToolTipTitle='Информация для оператора' onClick={tabActive.setValue}><IconHelp /></Tab.Item>
                    <Tab.Item tabName='logs' tabNameActive={tabActive.value} tabToolTipPlace='top-end' tabToolTipTitle='Журнал изменений' onClick={tabActive.setValue}><IconLogs /></Tab.Item> */}
                </Tab.Container>

                {<Loader isOpen={isLoadingCard} color='#f34e2e' title='Загрузка анкеты...' backdrop />}
            </Flex>
        </Drawer>
    </>
}